import { UniverseType } from 'src_common/common/universe';

type RoutesType = Record<string, string>;

const standardRoutes = {
    '/': 'homepage',

    '/account/:account/:static': 'homepage',
    '/account/:account': 'homepage',

    '/event/:id/:slug': 'event',
    '/event/:id': 'event',

    '/event/:id/:eventId/:slug/:type': 'sport',
    '/event/:id/:eventId/:slug': 'sport',
    '/event/:id/:eventId': 'sport',

    '/sport/:id/:type': 'sport',
    '/sport/:id': 'sport',
    '/sport-special/:id': 'sport-special',

    '/competition/:id/:slug': 'competition',
    '/competition/:id': 'competition',

    '/racecard/:sport/:collection/:selected': 'racecard',
    '/racecard/:sport/:collection/:racecardBuildIds/:selected': 'racecard',
    '/racecard/:sport/:collection': 'racecard',

    '/search': 'search',

    '/inplay': 'inplay',

    '/navigation-sports': 'navigation-sports',
    '/notifications-list': 'notifications-list',

    '/page/:id': 'page',
    '/error/:code': 'error',

    '/home': 'landing-home', //no component on /home check index.init.tsx
};

const starRoutesConfig = {
    ...standardRoutes,
    '/starevents': 'starevents',
    '/sports': 'sports',
};

const dragonBetRoutesConfig = {
    ...standardRoutes,
    '/welshevents': 'starevents',
    '/sports': 'sports',
    '/sport': 'sports',
};

const akBetsRoutesConfig = {
    ...standardRoutes,
    '/aks-big-prices': 'starevents',
};

const routesExtendsByCasino = (routes: RoutesType): RoutesType => ({
    ...routes,
    '/casino': 'casino',
    '/casino/:gameid': 'casino',
    '/casino/proceed/:sessionId': 'casino',
    '/virtuals': 'virtuals',
    '/virtuals/:activeGameId': 'virtuals',
    '/virtuals/proceed/:sessionId': 'virtuals',
    '/live-casino': 'live-casino',
    '/live-casino/:gameid': 'live-casino',
    '/live-casino/proceed/:sessionId': 'live-casino',
});

const getPathForUniverse = (universe: UniverseType): RoutesType => {
    if (universe === 'star') {
        return starRoutesConfig;
    }

    if (universe === 'dragonbet') {
        return dragonBetRoutesConfig;
    }

    if (universe === 'akbets') {
        return akBetsRoutesConfig;
    }

    return standardRoutes;
};

export const configRoutes = (universe: UniverseType): RoutesType => {
    const universeRoutes = getPathForUniverse(universe);

    return routesExtendsByCasino(universeRoutes);
};
